import Resource from './Resource';

export default class GetAdmRegionsResource extends Resource {
  async result() {
    try {
      const { data, status } = await this.request.get('/regioes-adm');
      if (status === 200) {
        return data.reduce((total, item) => ({
          ...total,
          [item.id_regiao_adm]: {
            name: item.nome,
          }
        }), {});
      }
    } catch (error) {
      console.log(error); //eslint-disable-line
    }
    return {};
  }
}
